/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffVideoCompleteMultiPartUploadRequestPartsInner
 */
export interface PostLiffVideoCompleteMultiPartUploadRequestPartsInner {
    /**
     * 
     * @type {number}
     * @memberof PostLiffVideoCompleteMultiPartUploadRequestPartsInner
     */
    partNumber: number;
    /**
     * 
     * @type {string}
     * @memberof PostLiffVideoCompleteMultiPartUploadRequestPartsInner
     */
    eTag: string;
}

/**
 * Check if a given object implements the PostLiffVideoCompleteMultiPartUploadRequestPartsInner interface.
 */
export function instanceOfPostLiffVideoCompleteMultiPartUploadRequestPartsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partNumber" in value;
    isInstance = isInstance && "eTag" in value;

    return isInstance;
}

export function PostLiffVideoCompleteMultiPartUploadRequestPartsInnerFromJSON(json: any): PostLiffVideoCompleteMultiPartUploadRequestPartsInner {
    return PostLiffVideoCompleteMultiPartUploadRequestPartsInnerFromJSONTyped(json, false);
}

export function PostLiffVideoCompleteMultiPartUploadRequestPartsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffVideoCompleteMultiPartUploadRequestPartsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partNumber': json['partNumber'],
        'eTag': json['eTag'],
    };
}

export function PostLiffVideoCompleteMultiPartUploadRequestPartsInnerToJSON(value?: PostLiffVideoCompleteMultiPartUploadRequestPartsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partNumber': value.partNumber,
        'eTag': value.eTag,
    };
}

